<template>
  <van-tabbar route>
    <van-tabbar-item replace to="/person" icon="user-o">
      个人中心
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: "VantTabbar",
  props: {
    active: Number,
  },
  data() {
    return {
      // active: 0,
    };
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VantTabbar/VantTabbar.vue